import InformationBarAPI from './information-bar-api';

export type {
  InformationBarAllergiesList,
  InformationBarAllergy,
  InformationBarField,
} from './information-bar-api';

export default InformationBarAPI;
